var MobileDetect = require('mobile-detect');

module.exports = () => {
    var md = new MobileDetect(window.navigator.userAgent);

    if(md.tablet()) {
        return true;
    }

    if(md.phone()) {
        return true;
    }

    return false;
};